import axios from "axios";

// we need to pass the baseURL as an object
const API = axios.create({
  baseURL: process.env.REACT_APP_API_MI_URL,
});

export default API;
